import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import theme from './theme';
import { get, COMMON, TYPOGRAPHY, BORDER } from './constants';
import sx from './sx';
var Header = styled.div.withConfig({
  displayName: "Header",
  componentId: "o06c91-0"
})(["z-index:32;display:flex;padding:", ";font-size:", ";line-height:", ";color:", ";background-color:", ";align-items:center;flex-wrap:nowrap;", " ", " ", ";"], get('space.3'), get('fontSizes.1'), get('lineHeights.default'), get('colors.whitefade70'), get('colors.bg.grayDark'), COMMON, BORDER, sx);
Header.Item = styled.div.withConfig({
  displayName: "Header__Item",
  componentId: "o06c91-1"
})(["display:flex;margin-right:", ";align-self:stretch;align-items:center;flex-wrap:nowrap;", ";", ";", ";", ";"], get('space.3'), function (props) {
  return props.full && css(["flex:auto;"]);
}, COMMON, BORDER, sx);
Header.Item.displayName = 'Header.Item';
Header.Link = styled.a.attrs(function (props) {
  var isReactRouter = typeof props.to === 'string';

  if (isReactRouter) {
    // according to their docs, NavLink supports aria-current:
    // https://reacttraining.com/react-router/web/api/NavLink/aria-current-string
    return {
      'aria-current': 'page'
    };
  } else {
    return {};
  }
}).withConfig({
  displayName: "Header__Link",
  componentId: "o06c91-2"
})(["font-weight:", ";color:", ";white-space:nowrap;cursor:pointer;text-decoration:none;display:flex;align-items:center;&:hover,&:focus{color:", ";}", ";", ";", ";", ";"], get('fontWeights.bold'), get('colors.text.white'), get('colors.whitefade70'), COMMON, BORDER, TYPOGRAPHY, sx);
Header.Link.displayName = 'Header.Link';
Header.propTypes = _objectSpread({}, sx.propTypes, {}, COMMON.propTypes, {}, BORDER.propTypes);
Header.defaultProps = {
  theme: theme
};
Header.Item.defaultProps = {
  theme: theme
};
Header.Item.propTypes = _objectSpread({
  full: PropTypes.bool
}, COMMON.propTypes, {}, BORDER.propTypes, {}, sx.propTypes);
Header.Link.defaultProps = {
  theme: theme
};
Header.Link.propTypes = _objectSpread({
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  href: PropTypes.string,
  theme: PropTypes.object
}, COMMON.propTypes, {}, BORDER.propTypes, {}, TYPOGRAPHY.propTypes, {}, sx.propTypes);
export default Header;